// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_user_container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
  width: 100%;
}

.search_user_container input {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  width: 90%;
  background-color: var(--bg-card);
  color: var(--text-primary);
}

.search_user_container input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

.search_user_selected {
  max-width: 100%;
  border: 1px solid var(--primary);
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  background-color: var(--primary-light);
  width: 90%;
}

.search_user_not_selected {
  max-width: 100%;
  width: 95%;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.search_user_not_selected:hover {
  background-color: var(--bg);
}

.search_user_selected p,
.search_user_not_selected p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.search_user_users_list_box {
  position: absolute;
  background-color: var(--bg-card);
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 400px;
  overflow-y: auto;
  width: 90%;
  top: 100%;
  left: 0;
  z-index: 10;
  padding: 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-lg);
}

.input_selectedUser {
  position: relative;
}

.relative {
  position: relative;
}

.delete_item_select {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-size: 12px;
  transition: background-color var(--transition-fast);
}

.delete_item_select:hover {
  background-color: var(--primary-hover);
}

search_user_item_selectMatchingUser {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchUser/SearchUser.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,+BAA+B;EAC/B,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".search_user_container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 15px;\n  width: 100%;\n}\n\n.search_user_container input {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 10px 14px;\n  border-radius: var(--radius-sm);\n  width: 90%;\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n}\n\n.search_user_container input:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\n.search_user_selected {\n  max-width: 100%;\n  border: 1px solid var(--primary);\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  background-color: var(--primary-light);\n  width: 90%;\n}\n\n.search_user_not_selected {\n  max-width: 100%;\n  width: 95%;\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.search_user_not_selected:hover {\n  background-color: var(--bg);\n}\n\n.search_user_selected p,\n.search_user_not_selected p {\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.search_user_users_list_box {\n  position: absolute;\n  background-color: var(--bg-card);\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 400px;\n  overflow-y: auto;\n  width: 90%;\n  top: 100%;\n  left: 0;\n  z-index: 10;\n  padding: 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-lg);\n}\n\n.input_selectedUser {\n  position: relative;\n}\n\n.relative {\n  position: relative;\n}\n\n.delete_item_select {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  background-color: var(--primary);\n  border-radius: 50%;\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  font-size: 12px;\n  transition: background-color var(--transition-fast);\n}\n\n.delete_item_select:hover {\n  background-color: var(--primary-hover);\n}\n\nsearch_user_item_selectMatchingUser {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
